import React from "react";
import "./OfferingCard.css";
import rightarrow from "../../assets/utility_images/right-arrow-icon.svg";
import rightarrowWhite from "../../assets/utility_images/right-arrow-icon-white.svg";
import { Link } from "react-router-dom";

const OfferingCard = ({ number, icon, title, description, buttonName }) => {
  // Generate a slug from the title
  const titleMapping = {
    "클라우드 컴퓨팅": "Cloud Computing",
    "소프트웨어 공학": "Software Engineering",
    "빅데이터": "Big Data",
    "임베디드 시스템": "Embedded Systems",
    // Add other mappings here
  };

  // Function to get English title
  const getEnglishTitle = (localizedTitle) =>
    titleMapping[localizedTitle] || localizedTitle;

  // Generate a slug from the English title
  const generateName = (text) => {
    return text
      .toLowerCase()
      .replace(/\s+/g, "") // Replace spaces with hyphens
      .replace(/[^\w-]+/g, ""); // Remove invalid characters
  };

  const englishTitle = getEnglishTitle(title); // Convert localized title to English
  const cardTitle = generateName(englishTitle); // Generate slug from English title

  return (
    <div className="offering-card">
      <div className="number-box d-flex align-items-center justify-content-around">
        {number}
      </div>
      <div className="description-offering d-flex flex-column">
        <div className="offering-icon">
          <img src={icon} alt={title} loading="lazy" />
        </div>
        <div className="horizontal-lines d-flex ">
          <div className="line-1"></div>
          <div className="line-2"></div>
        </div>

        <div className="offering-desc d-flex flex-column ">
          <div className="offering-title">{title}</div>
          <div className="offering-text">{description}</div>
          <Link
            className="linkToPage"
            to={`/discover/${cardTitle}`} // Use the slug in the URL
            target="_blank"
          >
            <button className="btn-offering-card d-flex justify-content-evenly align-items-center">
              {buttonName}
              <div className="hero-btn">
                <img
                  className="hover-arrow"
                  src={rightarrow}
                  alt=""
                  loading="lazy"
                />
                <img
                  className="hover-arrow-white"
                  src={rightarrowWhite}
                  alt=""
                  loading="lazy"
                />
              </div>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OfferingCard;
